import {
  createStandardAction,
  createReducer,
  ActionType,
  StateType
} from "typesafe-actions";
import _ from "lodash";

type DesktopDeviceSettingChangePayload = {
  accessor: string;
  change: Change;
};

export enum SettingChange {
  EDITED = "edited",
  REVERTED = "reverted"
}

export type Change = "edited" | "reverted" | "";
export type DesktopDeviceSettingsChanges = {
  [accessor: string]: Change;
};

export const desktopDeviceSettingChanged = createStandardAction(
  "DESKTOP_DEVICE_SETTING_CHANGED"
)<DesktopDeviceSettingChangePayload>();
export const resetDesktopDeviceSettingChanges = createStandardAction(
  "RESET_DESKTOP_DEVICE_SETTING_CHANGES"
)();
export const resetDesktopDeviceSettingsInheritanceAndNav = createStandardAction(
  "RESET_DESKTOP_DEVICE_SETTING_INHERITANCE_AND_NAV"
)();

const DesktopDeviceSettingsActions = {
  desktopDeviceSettingChanged,
  resetDesktopDeviceSettingChanges,
  resetDesktopDeviceSettingsInheritanceAndNav
};
export type DesktopDeviceSettingsAction = ActionType<
  typeof DesktopDeviceSettingsActions
>;

export const defaultDesktopDeviceSettingsState: DesktopDeviceSettingsChanges = {};

export const DesktopDeviceSettingsReducer = createReducer(
  defaultDesktopDeviceSettingsState
)
  .handleAction(desktopDeviceSettingChanged, (state, action) => {
    const { accessor, change } = action.payload;

    // only update state if needed
    if (change !== state[accessor]) {
      if (change) {
        // add change to state
        return {
          ...state,
          [accessor]: change
        };
      } else {
        // delete change from state (and delete empty objects along path if any)
        const newState = _.cloneDeep(state);
        _.unset(newState, [accessor]);
        return newState;
      }
    }

    return state;
  })
  .handleAction(
    resetDesktopDeviceSettingChanges,
    (state, action) => defaultDesktopDeviceSettingsState
  )
  .handleAction(
    resetDesktopDeviceSettingsInheritanceAndNav,
    (state, action) => defaultDesktopDeviceSettingsState
  );

export type DesktopDeviceSettingsState = StateType<
  typeof DesktopDeviceSettingsReducer
>;
